module.exports = __webpack_public_path__ + "static/16-50bec9d42f999f834e5172966efd2383.jpeg";